import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IonInput } from '@ionic/angular';

@Component({
  selector: 'app-select-search-filter',
  templateUrl: './select-search-input-filter.component.html',
  styleUrls: ['./select-search-input-filter.component.scss'],
})
export class SelectSearchInputComponentFilter {
  @ViewChild('inputField', { static: false }) inputField!: IonInput;
  @Input() isRequired: boolean = true;
  @Input() innerClass: string = '';
  @Input() allData: any = [];
  @Input() label: string = '';
  @Input() buttonLabel: string = '';
  @Input() selectInput: any = null;
  @Input() selectInputId: any = null;
  @Output() selectInputChange = new EventEmitter<any>();
  @Output() selectInputIdChange = new EventEmitter<any>();
  @ViewChild('popover', { static: true }) popover!: ElementRef;
  @Input() disabled: boolean = false;

  filteredData: any = [];
  inputFocus: boolean = false;
  optSelected: boolean = false;
  inputWasChanged: boolean = false;
  lastKeyPressed: string = '';
  isPopoverOpen: boolean = false;
  popoverEvent: any;
  form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      input: [null],
    });
  }

  openFilterPopover(event: Event) {
    this.popoverEvent = event;
    this.isPopoverOpen = true;
  }

  closePopover() {
    this.isPopoverOpen = false;
    this.inputFocus = false;
    this.filteredData = this.allData;
    this.optSelected = false;
    this.inputWasChanged = false;
  
    if (!this.form.get('input')?.value) {
      this.filteredData = this.allData;
    }
  }

  ngOnInit(): void {
    document.documentElement.style.setProperty('--popover-height', '4rem');
    if (this.selectInput) {
      this.form.patchValue({ input: this.selectInput });
    }
    this.filteredData = this.allData;
    this.setFieldValidation();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['allData']) {
      this.filteredData = this.allData;
    }

    if (changes['selectInput']) {
      this.form.patchValue({ input: this.selectInput });
    }
  }

  setFieldValidation() {
    const inputControl = this.form.get('input');

    if (!inputControl) return;

    if (this.isRequired) {
      inputControl.setValidators([Validators.required]);
    } else {
      inputControl.clearValidators();
    }
    inputControl.updateValueAndValidity();
  }

  onKeyDown(event: KeyboardEvent) {
    this.lastKeyPressed = event.key;
  }

  onFocus(): void {
    if (this.lastKeyPressed === 'Clear') {
      this.lastKeyPressed = '';
    }

    this.lastKeyPressed = '';
    this.inputFocus = true;
    this.inputWasChanged = false;

    if (!this.form.get('input')?.value) {
      this.filteredData = this.allData;
    }

    this.isPopoverOpen = true;
    document.documentElement.style.setProperty('--popover-height', '15rem');
  }

  onInputChange() {
    this.inputWasChanged = true;
  }

  onBlur() {
    document.documentElement.style.setProperty('--popover-height', '15rem');
    if (!this.inputFocus) {
      return false;
    }

    if (this.lastKeyPressed === 'Tab') {
      return false;
    }

    return this.closeList();
  }

  onListBlur(event: FocusEvent) {
    const relatedTarget = event.relatedTarget as HTMLElement;

    if (!relatedTarget || !this.isFocusInsideList(relatedTarget)) {
      return this.closeList();
    }
  }

  clearInput() {
    this.lastKeyPressed = 'Clear';

    this.clearInputAction();

    setTimeout(() => {
      this.inputField.getInputElement().then((nativeInput) => {
        nativeInput.value = '';
        nativeInput.blur();
      });
    }, 0);

    this.inputFocus = false;
    this.inputWasChanged = false;
    this.filteredData = this.allData;
  }

  private clearInputAction() {
    this.form.patchValue({ input: null });
    this.selectInput = null;
    this.selectInputId = null;
    this.selectInputChange.emit(null);
    this.selectInputIdChange.emit(null);
  }

  private isFocusInsideList(target: HTMLElement): boolean {
    const listElement = document.querySelector('.filtered-list');
    return listElement ? listElement.contains(target) : false;
  }

  private closeList() {
    setTimeout(() => {
      this.inputFocus = false;
      if (this.inputWasChanged && !this.optSelected) {
        this.clearInputAction();
        document.documentElement.style.setProperty('--popover-height', '4rem');
      }
    }, 150);
  }

  onSearch(event: Event) {
    if (this.lastKeyPressed === 'Tab') {
      return false;
    }

    const filterValue = (event.target as HTMLInputElement).value;
    this.selectInputIdChange.emit(null);
    this.selectInputChange.emit(null);

    if (filterValue) {
      this.optSelected = false;
      const lowerCaseSearchTerm = filterValue.toLowerCase();

      return (this.filteredData = this.allData.filter((data: any) =>
        data.nome.toLowerCase().includes(lowerCaseSearchTerm)
      ));
    }

    return (this.filteredData = this.allData);
  }

  selectValue(value: any) {
    this.optSelected = true;
    this.filteredData = [];
    this.form.patchValue({ input: value.nome });
    this.selectInput = value.nome;
    this.selectInputId = value.id;
    this.selectInputChange.emit(value.nome);
    this.selectInputIdChange.emit(value.id);
    document.documentElement.style.setProperty('--popover-height', '4rem');
    this.closePopover();
  }

  keydownSelectValue(event: KeyboardEvent, value: any) {
    if (
      event.key === 'Spacebar' ||
      event.key === 'Enter' ||
      event.key === ' '
    ) {
      event.preventDefault();
      this.selectValue(value);
    }
  }
}